import { Skeleton } from '@app/components/various/Skeleton';
import { getCheckoutFields } from '@app/ducks';
import { isDefined } from '@app/utils/is';
import { useSelector } from 'react-redux';

import { AddressSummarySkeleton } from '../AddressSummary/AddressSummarySkeleton';

export const CheckoutAdditionalSkeleton = () => {
  const checkoutFields = useSelector(getCheckoutFields);
  const { additionalNotes } = checkoutFields;

  return (
    <div className="box">
      <div className="mb-5 max-w-72">
        <Skeleton type="text" size="large" />
      </div>
      <div className="space-y-5">
        <AddressSummarySkeleton />
        {isDefined(additionalNotes) && <Skeleton type="rectangle" aspectRatio={1 / 5} />}
      </div>
    </div>
  );
};
